import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { LiquiditySummaryActionPayload } from './actions';
import { LiquiditySummaryWidgetState } from './LiquiditySummaryWidgetState';
import { buildLiquiditySummaryConfigSlice } from 'widgets/liquiditySummary/store/configuration/configSlice';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';

const { reducer: configReducer } = buildLiquiditySummaryConfigSlice();

const widgetStateReducer = combineReducers<LiquiditySummaryWidgetState>({
    config: configReducer,
});

export const liquiditySummaryWidgetsReducer = createWidgetsReducer<
    LiquiditySummaryWidgetState,
    LiquiditySummaryActionPayload
>(WidgetType.LIQUIDITY_SUMMARY, widgetStateReducer);
